import isAnswered from "components/Loans/LoanStepper/utils/isAnswered";
import updateLoanSectionController from "components/Loans/LoanStepper/components/lib/updateLoanSectionController";
import updateLoanSectionController2 from "components/Loans/LoanStepper/components/lib/updateLoanSectionController2";

const calculateAndSetPercentCompleted = (
  answers,
  stepID,
  loanSectionController,
  setLoanSectionController,
  user,
  loan
) => {
  let answered, sectionPercentCompleted, updatedLoanSectionController;

  updatedLoanSectionController = structuredClone(loanSectionController);

  answered = answers.filter((answer) => {
    return isAnswered(answer);
  });

  sectionPercentCompleted = (answered.length / answers.length) * 100;

  updatedLoanSectionController[stepID].percentCompleted =
    sectionPercentCompleted;

  // change priority to completed when hit 100
  // to suddent of a change from UI perspective
  // if (sectionPercentCompleted === 100) {
  //   updatedLoanSectionController[stepID].priority = "completed";
  // }

  // ONLY (RE)SET PERCENT COMPLETED IF IT CHANGES ACROSS THE OBJECT
  if (
    JSON.stringify(loanSectionController) !==
    JSON.stringify(updatedLoanSectionController)
  ) {
    updateLoanSectionController2(
      loan,
      setLoanSectionController,
      updatedLoanSectionController,
      user,
      stepID
    );
  }
};

export default calculateAndSetPercentCompleted;
